import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = {
  key: 0
};
var _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", {
  "class": "mb-8 text-3xl font-bold"
}, "Weekly Campaign Targets Report", -1);
var _hoisted_3 = /*#__PURE__*/_createElementVNode("p", {
  "class": "mb-8 leading-normal"
}, "Sorry you do not have any data associated with your account.", -1);
var _hoisted_4 = {
  key: 1
};
var _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", {
  "class": "mb-8 text-3xl font-bold"
}, "Weekly Campaign Targets Report", -1);
var _hoisted_6 = {
  "class": "bg-white rounded-md shadow overflow-x-auto mb-6"
};
var _hoisted_7 = {
  "class": "flex justify-end"
};
var _hoisted_8 = {
  "class": "w-full flex justify-between p-4"
};
var _hoisted_9 = ["onClick"];
var _hoisted_10 = {
  "class": "text-center"
};
var _hoisted_11 = {
  "class": "text-center"
};
var _hoisted_12 = {
  "class": "flex justify-end"
};
var _hoisted_13 = {
  "class": "m-4"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Head = _resolveComponent("Head");
  var _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item");
  var _component_el_breadcrumb = _resolveComponent("el-breadcrumb");
  var _component_el_switch = _resolveComponent("el-switch");
  var _component_el_skeleton_item = _resolveComponent("el-skeleton-item");
  var _component_el_table_column = _resolveComponent("el-table-column");
  var _component_el_table = _resolveComponent("el-table");
  var _component_el_skeleton = _resolveComponent("el-skeleton");
  var _component_el_pagination = _resolveComponent("el-pagination");
  return $props.weeks == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_Head, {
    title: "Weekly Campaign Targets Report"
  }), _hoisted_2, _hoisted_3])) : (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_Head, {
    title: "Weekly Campaign Targets Report"
  }), _hoisted_5, _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createVNode(_component_el_breadcrumb, null, {
    "default": _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.tabsData, function (tab, tab_key) {
        return _openBlock(), _createBlock(_component_el_breadcrumb_item, {
          onClick: function onClick($event) {
            return $options.goBack(tab, tab_key);
          }
        }, {
          "default": _withCtx(function () {
            return [_createTextVNode(_toDisplayString(tab.user_name), 1)];
          }),
          _: 2
        }, 1032, ["onClick"]);
      }), 256))];
    }),
    _: 1
  }), _createVNode(_component_el_switch, {
    modelValue: $data.valueType,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return $data.valueType = $event;
    }),
    size: "large",
    "active-value": "percentage",
    "active-text": "Percentage",
    "inactive-text": "Absolute Value",
    "inactive-value": "absolute"
  }, null, 8, ["modelValue"]), _createElementVNode("button", {
    onClick: _cache[1] || (_cache[1] = function () {
      return $options.reset && $options.reset.apply($options, arguments);
    }),
    "class": "ml-3 text-white focus:text-indigo-500 text-sm bg-indigo-800 px-6 rounded-md",
    type: "button"
  }, "Reset")])]), _createElementVNode("div", null, [_createVNode(_component_el_skeleton, {
    loading: $data.isLoadingTargetData,
    animated: "",
    count: 9
  }, {
    template: _withCtx(function () {
      return [_createElementVNode("div", null, [_createVNode(_component_el_skeleton_item, {
        variant: "h3"
      })])];
    }),
    "default": _withCtx(function () {
      return [_createVNode(_component_el_table, {
        data: $data.targetDataList,
        style: {
          "width": "100%"
        },
        ref: "targetData"
      }, {
        "default": _withCtx(function () {
          return [_createVNode(_component_el_table_column, {
            label: "User"
          }, {
            "default": _withCtx(function (scope) {
              return [_createElementVNode("a", {
                onClick: function onClick($event) {
                  return $options.getUserData(scope.row);
                },
                "class": "text-center cursor-pointer"
              }, _toDisplayString(scope.row.user_name), 9, _hoisted_9)];
            }),
            _: 1
          }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.weekDataList, function (w, key) {
            return _openBlock(), _createBlock(_component_el_table_column, null, {
              header: _withCtx(function () {
                return [_createElementVNode("div", _hoisted_10, "Week (" + _toDisplayString(w.week_number) + ", " + _toDisplayString(w.year) + ")", 1), _createElementVNode("div", _hoisted_11, _toDisplayString(w.start_date) + " to " + _toDisplayString(w.end_date), 1)];
              }),
              "default": _withCtx(function () {
                return [_createVNode(_component_el_table_column, {
                  label: "Contacts"
                }, {
                  "default": _withCtx(function (scope) {
                    return [scope.row[key].contacts_percent != -1 && $data.valueType == 'percentage' ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      "class": _normalizeClass(["text-center", scope.row[key].contacts_background]),
                      style: {
                        "font-weight": "bold"
                      }
                    }, _toDisplayString(scope.row[key].contacts_percent), 3)) : _createCommentVNode("", true), scope.row[key].contacts != -1 && $data.valueType == 'absolute' ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      "class": _normalizeClass(["text-center", scope.row[key].contacts_background]),
                      style: {
                        "font-weight": "bold"
                      }
                    }, _toDisplayString(scope.row[key].contacts), 3)) : _createCommentVNode("", true)];
                  }),
                  _: 2
                }, 1024), _createVNode(_component_el_table_column, {
                  label: "Companies"
                }, {
                  "default": _withCtx(function (scope) {
                    return [scope.row[key].companies_percent != -1 && $data.valueType == 'percentage' ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      "class": _normalizeClass(["text-center", scope.row[key].companies_background]),
                      style: {
                        "font-weight": "bold"
                      }
                    }, _toDisplayString(scope.row[key].companies_percent), 3)) : _createCommentVNode("", true), scope.row[key].companies != -1 && $data.valueType == 'absolute' ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      "class": _normalizeClass(["text-center", scope.row[key].companies_background]),
                      style: {
                        "font-weight": "bold"
                      }
                    }, _toDisplayString(scope.row[key].companies), 3)) : _createCommentVNode("", true)];
                  }),
                  _: 2
                }, 1024)];
              }),
              _: 2
            }, 1024);
          }), 256))];
        }),
        _: 1
      }, 8, ["data"])];
    }),
    _: 1
  }, 8, ["loading"]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createVNode(_component_el_skeleton, {
    loading: $data.isLoadingTargetData,
    animated: "",
    count: 1
  }, {
    template: _withCtx(function () {
      return [_createElementVNode("div", null, [_createVNode(_component_el_skeleton_item, {
        variant: "h3"
      })])];
    }),
    "default": _withCtx(function () {
      return [_createVNode(_component_el_pagination, {
        background: "",
        layout: "prev, pager, next",
        total: $props.weeks,
        "current-page": $data.currentPage,
        "default-page-size": 4,
        onCurrentChange: $options.pageChange
      }, null, 8, ["total", "current-page", "onCurrentChange"])];
    }),
    _: 1
  }, 8, ["loading"])])])])])]));
}